import React from 'react';
import './LoadingSpinner.css';

function LoadingSpinner() {
    return (
        <div className="spinner-overlay" role="status" aria-live="polite">
            <div className="spinner" aria-hidden="true"></div>
            <div className="spinner-label">载入中</div>
        </div>
    );
}

export default LoadingSpinner;
